var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_5.Link"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m324.958 187.046c58.347 58.407 57.546 152.048.352 209.56-.107.117-.234.244-.352.361l-65.625 65.625c-57.881 57.881-152.05 57.873-209.922 0-57.881-57.871-57.881-152.05 0-209.921l36.236-36.236c9.609-9.609 26.158-3.223 26.654 10.357.633 17.307 3.736 34.694 9.463 51.485 1.939 5.686.554 11.975-3.694 16.223l-12.78 12.78c-27.369 27.369-28.228 71.933-1.128 99.57 27.367 27.909 72.35 28.075 99.927.498l65.625-65.615c27.53-27.53 27.415-72.028 0-99.443-3.614-3.607-7.255-6.41-10.099-8.368-4.079-2.801-6.595-7.366-6.784-12.311-.387-10.319 3.27-20.953 11.424-29.107l20.561-20.561c5.392-5.392 13.85-6.054 20.102-1.69 7.158 4.999 13.865 10.618 20.04 16.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m462.59 49.408c-57.872-57.873-152.041-57.881-209.922 0l-65.625 65.625c-.117.117-.244.244-.352.361-57.193 57.512-57.995 151.153.352 209.56 6.175 6.174 12.88 11.794 20.04 16.793 6.252 4.363 14.711 3.7 20.102-1.69l20.561-20.561c8.154-8.154 11.811-18.788 11.424-29.107-.189-4.945-2.705-9.509-6.784-12.31-2.844-1.958-6.484-4.761-10.099-8.368-27.415-27.415-27.53-71.913 0-99.443l65.625-65.615c27.577-27.577 72.559-27.411 99.927.498 27.1 27.637 26.242 72.201-1.128 99.57l-12.78 12.78c-4.248 4.248-5.634 10.537-3.694 16.223 5.727 16.791 8.83 34.179 9.463 51.485.497 13.58 17.045 19.967 26.654 10.357l36.236-36.236c57.88-57.872 57.88-152.051 0-209.922z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cfe86e603009a791fb590cb27d45d709.svg";
export { ForwardRef as ReactComponent };